const { LAYER_ROLES } = require('../layerTypes');

const VARIATION_TEXT_FIELDS = [
    LAYER_ROLES.BRAND_NAME,
    LAYER_ROLES.SLOGAN
];

module.exports = {
    VARIATION_TEXT_FIELDS
};
